import { Image, Spin, Empty, Divider } from "antd";
import { PictureOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import axios from "axios";

export const FotosAsistenciaViewer = ({ idfotos }) => {
  const [fotos, setFotos] = useState({});
  const [loading, setLoading] = useState({});
  const token = localStorage.getItem("token");
  const URL_BASE = window["runConfig"].URL_BASE;

  useEffect(() => {
    if (!idfotos || idfotos.length === 0) return;

    idfotos.forEach(async (idFoto) => {
      setLoading((prev) => ({ ...prev, [idFoto]: true }));
      try {
        const response = await axios.get(
          `${URL_BASE}/api/AccesoProveedores/GetFotos/${idFoto}`,
          {
            responseType: "blob",
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const blobUrl = URL.createObjectURL(response.data);
        setFotos((prev) => ({ ...prev, [idFoto]: blobUrl }));
      } catch (error) {
        console.error(`Error cargando foto ${idFoto}:`, error);
      } finally {
        setLoading((prev) => ({ ...prev, [idFoto]: false }));
      }
    });

    // limpiar
    return () => {
      Object.values(fotos).forEach((url) => {
        if (url) URL.revokeObjectURL(url);
      });
    };
  }, [idfotos]);

  if (!idfotos || idfotos.length === 0) {
    return (
      <>
        <Divider orientation="left">Fotos de Asistencia</Divider>
        <Empty
          image={<PictureOutlined style={{ fontSize: 48, color: "#d9d9d9" }} />}
          imageStyle={{ height: 48, marginBottom: 8 }}
          description="No hay fotos disponibles"
        />
      </>
    );
  }

  return (
    <>
      <Divider orientation="left">Fotos de Asistencia</Divider>
      <Image.PreviewGroup>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))",
            gap: 12,
          }}
        >
          {idfotos.map((idFoto) => (
            <div key={idFoto} style={{ textAlign: "center" }}>
              {loading[idFoto] ? (
                <div
                  style={{
                    width: 100,
                    height: 100,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px dashed #d9d9d9",
                    borderRadius: 4,
                  }}
                >
                  <Spin />
                </div>
              ) : fotos[idFoto] ? (
                <Image
                  src={fotos[idFoto]}
                  alt={`Foto ${idFoto}`}
                  width={100}
                  height={100}
                  style={{ objectFit: "cover", borderRadius: 4 }}
                  preview={{
                    mask: "Ver",
                  }}
                />
              ) : null}
            </div>
          ))}
        </div>
      </Image.PreviewGroup>
    </>
  );
};
